import { render, staticRenderFns } from "./cookie-law.vue?vue&type=template&id=a0fc177a&"
import script from "./cookie-law.vue?vue&type=script&lang=js&"
export * from "./cookie-law.vue?vue&type=script&lang=js&"
import style0 from "./cookie-law.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fc177a')) {
      api.createRecord('a0fc177a', component.options)
    } else {
      api.reload('a0fc177a', component.options)
    }
    module.hot.accept("./cookie-law.vue?vue&type=template&id=a0fc177a&", function () {
      api.rerender('a0fc177a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/cookie-law.vue"
export default component.exports